export default {
  backButton: 'Back to team report',
};
